import { useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import "../Styles/Feefrequency.css";
import { simplePostCall } from "../api/ApiServices";
import ApiConfig from "../api/ApiConfig";
import ScaleLoader from "react-spinners/ScaleLoader";
import { FaEye } from "react-icons/fa";

export default function FeeFrequenciesTable() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [studentList, setStudentList] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  
  // FIXED: Set to null so the conditional render shows the table by default
  const [AccountantStudentFeeListView, setAccountantStudenFeetListView] = useState(null);

  useEffect(() => {
    loadDataStudentFee();
  }, []);

  const loadDataStudentFee = async (searchQuery = "") => {
    setIsLoading(true);
    const customer_id = localStorage.getItem("customer_id");
    const api_key = localStorage.getItem("api_key");

    const requestBody = {
      customer_id: Number(customer_id),
      api_key: api_key,
      fee_search: searchQuery,
    };

    try {
      const response = await simplePostCall(
        ApiConfig.FeeStudentList,
        JSON.stringify(requestBody)
      );

      if (response?.result) {
        setStudentList(response.data);
        // Ensure detail view is closed when loading the main list
        setAccountantStudenFeetListView(null);
      } else {
        setStudentList([]);
      }
    } catch (error) {
      console.error("Error loading student list:", error);
      setStudentList([]);
    } finally {
      setIsLoading(false);
    }
  };

  const loadDataStudentFeeView = async (id) => {
    setIsLoading(true);
    const customer_id = localStorage.getItem("customer_id");
    const api_key = localStorage.getItem("api_key");

    const requestBody = {
      customer_id: Number(customer_id),
      api_key: api_key,
      fee_frequency_id: id,
    };

    try {
      const response = await simplePostCall(
        ApiConfig.FeeStudentListView,
        JSON.stringify(requestBody)
      );
      if (response?.result) {
        // Set the data which triggers the FeeDetailView
        setAccountantStudenFeetListView(response.data || response); 
      } else {
        alert("No data found for this student");
      }
    } catch (error) {
      console.error("Error loading student details:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleBack = () => {
    setAccountantStudenFeetListView(null);
  };

  // CONDITIONAL RENDERING: 
  // Because AccountantStudentFeeListView starts as null, this is skipped initially.
  if (AccountantStudentFeeListView) {
    return <FeeDetailView data={AccountantStudentFeeListView} onBack={handleBack} />;
  }

  return (
    <div className="fee-container my-4">
      <div className="special-header panel-white-all">
        <h4 className="page-title mt-1">Student Fee List</h4>
      </div>

      <div className="table-top-filters d-flex flex-wrap gap-3 mb-3">
        <div style={{ position: "relative", maxWidth: "300px", right: '10px' }}>
          <input
            type="text"
            className="form-control"
            style={{ paddingRight: "40px", height: "40px", marginRight: "5px" }}
            placeholder="Search by Name/Admission..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && loadDataStudentFee(searchTerm)}
          />
          <i
            className="bi bi-search"
            style={{
              position: "absolute",
              right: "10px",
              
              top: "50%",
              transform: "translateY(-50%)",
              cursor: "pointer",
              color: "#6c757d",
            }}
            onClick={() => loadDataStudentFee(searchTerm)}
          ></i>
        </div>
      </div>

      <div className="card">
        <div className="card-body p-0">
          <div className="table-responsive">
            <table className="custom-table w-100">
              <thead>
                <tr style={{textAlign:'center'}}>
                  <th style={{paddingLeft:'80px'}}>Sr.No</th>
                  <th style={{paddingLeft:'80px'}}>Fee Frequency Name</th>
                  <th style={{paddingLeft:'80px'}}>Fee Frequency Status</th>
                  <th className="text-center" style={{paddingRight:'50px'}}>Action</th>
                </tr>
              </thead>
              <tbody>
                {isLoading ? (
                  <tr>
                    <td colSpan="4" className="text-center">
                      <ScaleLoader color="#F4BB44" style={{ padding: "10px" }} />
                    </td>
                  </tr>
                ) : studentList.length > 0 ? (
                  studentList.map((student, index) => (
                    <tr key={student.student_id || index}>
                      <td style={{paddingLeft:'90px'}}>{index + 1}</td>
                      <td style={{paddingLeft:'95px'}}>{student.fee_frequency_name}</td>
                      <td style={{paddingLeft:'115px'}}>{student.fee_frequency_status}</td>
                      <td className="text-center">
                        <button
                        style={{display:'flex', justifyContent:'center',alignItems:'center' , marginLeft:'40px', gap:'6px'}}
                          className="btn btn-sm"
                          onClick={() => loadDataStudentFeeView(student.fee_frequency_id)}
                          title="View"
                        >
                           <FaEye />
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" className="text-center">No students found</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

function FeeDetailView({ data, onBack }) {
  if (!data) return null;

  // Handling both array and object responses
  const invoice = Array.isArray(data) ? data[0] : data;
  const defaultAvatar = "https://stage.edsys.in/uploads/general/student_avatar.png";

  return (
    <div className="monthly-container my-4">
      <div className="special-header panel-white-all d-flex justify-content-between align-items-center">
        <h4 className="page-title">Invoice Details</h4>
        <button className="rounded text-white" style={{backgroundColor: "#5db2e8", border: "none", padding: "6px"}} onClick={onBack}>
          Back to List
        </button>
      </div>

      <div className="card col-md-12 mt-3">
        <div className="card-body p-3">
          <div className="text-center mb-3">
             <div style={{ width: "100px", height: "100px", margin: "0 auto", borderRadius: "50%", overflow: "hidden", border: "2px solid #ddd" }}>
                <img 
                  src={invoice.student_profilepicture && invoice.student_profilepicture !== "null" 
                    ? `https://stage.edsys.in/${invoice.student_profilepicture}` 
                    : defaultAvatar} 
                  alt="Profile"
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = defaultAvatar;
                  }}
                />
             </div>
          </div>

          <div className="table-responsive rounded">
            <table className="table table-bordered table-striped align-middle mb-0">
              <tbody>
                <tr>
                  <td className="fw-bold" style={{ width: "300px"  }}>No</td>
                  <td style={{ display:'flex', justifyContent:'center' , alignItems:'center', gap:'6px' }}>{invoice.fee_invoice_id || "N/A"}</td>
                </tr>
                <tr>
                  <td className="fw-bold">Fee Frequency Name</td>
                  <td style={{ display:'flex', justifyContent:'center' , alignItems:'center', gap:'6px'}}>{invoice.fee_frequency_name}</td>
                </tr>
                <tr>
                  <td className="fw-bold">Fee Frequency Status</td>
                  <td style={{ display:'flex', justifyContent:'center' , alignItems:'center', gap:'6px'}}>{invoice.fee_frequency_status}</td>
                </tr>
                <tr>
                  <td className="fw-bold">Status</td>
                  <td style={{ display:'flex', justifyContent:'center' , alignItems:'center', gap:'6px'}}>
                    <span className={`badge ${invoice.fee_frequency_status === "Active" || invoice.fee_frequency_status === "paid" ? "bg-success" : "bg-danger"}`}>
                      {invoice.fee_frequency_status}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
} 